import {
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/editor/dropdown-menu';
import { DropdownMenu } from '@/components/form/dropdown/Dropdown';
import { Property } from '@/components/form/fields/select/SelectInput';
import { InputProps, withField } from '@/components/form/fields/withField';
import SiChevronDown from '@/icons/SiChevronDown';
import SiClose from '@/icons/SiClose';
import SiPlus from '@/icons/SiPlus';
import { FC, ReactNode } from 'react';
import { Button } from '../../../components/form/Button';

interface Criteria {
  id: string;
  label: string | ReactNode;
  options: Property[];
}
interface CriteriaInputProps {
  criteria: Criteria[];
  placeholder?: string;
}
interface CriteriaProps {
  criteria: Criteria;
}
const CriteriaInput: FC<InputProps<Record<string, Property | null>> & CriteriaInputProps> = ({
  criteria = [],
  onChange,
  value = {},
  placeholder
}) => {
  const UnselectedCriteria: FC<CriteriaProps> = ({ criteria }) => (
    <Button
      onClick={() => {
        onChange({
          ...value,
          [criteria.id]: null
        });
      }}
    >
      <SiPlus className="text-xl" />
      <span>{criteria.label}</span>
    </Button>
  );

  const SelectedCriteria: FC<CriteriaProps> = ({ criteria }) => {
    const selectedOption = value[criteria.id];
    return (
      <div className="flex items-center">
        <div className="bg-primary-700 border-primary-700 relative z-10 flex items-center justify-center gap-1 overflow-clip rounded-lg border py-1.5 px-4 text-sm text-white">
          <span>{criteria.label}</span>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className="hover:bg-primary-std relative -left-2 flex cursor-pointer items-center justify-center rounded-r-lg border border-l-0 border-gray-200 py-1.5 pr-3 pl-5 text-sm">
              {selectedOption ? selectedOption.name : <span className="opacity-60">{placeholder}</span>}
              <SiChevronDown />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuGroup>
              {criteria.options.map(({ id, name }) => (
                <DropdownMenuItem
                  key={id}
                  className="text-secondary-std px-1.5 py-4"
                  onClick={() => onChange({ ...value, [criteria.id]: { id, name } })}
                >
                  <span>{name}</span>
                </DropdownMenuItem>
              ))}
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>

        <button
          type="button"
          className="mr-2 text-gray-400 hover:text-gray-500"
          onClick={() => {
            delete value[criteria.id];
            onChange(value);
          }}
        >
          <SiClose />
        </button>
      </div>
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {criteria.map(c => {
        if (value[c.id] !== undefined) {
          return <SelectedCriteria key={c.id} criteria={c} />;
        }
        return <UnselectedCriteria key={c.id} criteria={c} />;
      })}
    </div>
  );
};
export const CriteriaField = withField<Record<string, Property | null>, CriteriaInputProps>(CriteriaInput);
